/*
 * @Author: wsx
 * @Date: 2022-01-05 15:37:49
 * @LastEditTime: 2022-06-14 17:27:18
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description:
 */
export default [{
    path: "Organ",
    name: "Organ",
    component: () =>
      import ("@/views/system/organ.vue"),
    meta: {
      title: "部门管理"
    }
  },
  {
    path: "UserManage",
    name: "UserManage",
    component: () =>
      import ("@/views/system/UserManage.vue"),
    meta: {
      title: "用户管理"
    }
  },
  {
    path: "RoleManage",
    name: "RoleManage",
    component: () =>
      import ("@/views/system/RoleManage"),
    meta: {
      title: "角色管理"
    }
  },
  {
    path: "RegionManage",
    name: "RegionManage",
    component: () =>
      import ("@/views/system/RegionManage"),
    meta: {
      title: "区域管理"
    }
  },
  {
    path: "patrolMange",
    name: "patrolMange",
    component: () =>
      import ("@/views/system/patrolMange"),
    meta: {
      title: "巡防点管理"
    }
  },
  {
    path: "DataDictionary",
    name: "DataDictionary",
    component: () =>
      import ("@/views/system/DataDictionary"),
    meta: {
      title: "数据字典"
    }
  },
  {
    path: "MenuManage",
    name: "MenuManage",
    component: () =>
      import ("@/views/system/MenuManage"),
    meta: {
      title: "菜单管理"
    }
  },
  {
    path: "messageNotification",
    name: "messageNotification",
    component: () =>
      import ("@/views/system/messageCenter/messageNotification"),
    meta: {
      title: "消息通知"
    }
  },
  {
    path: "messagePush",
    name: "messagePush",
    component: () =>
      import ("@/views/system/messageCenter/messagePush"),
    meta: {
      title: "消息推送"
    }
  },
  {
    path: "logManagement",
    name: "logManagement",
    component: () =>
      import ("@/views/system/logManagement.vue"),
    meta: {
      title: "日志管理"
    }
  },
  {
    path: "systemTimeCalibration",
    name: "systemTimeCalibration",
    component: () =>
      import ("@/views/system/systemTimeCalibration.vue"),
    meta: {
      title: "系统时间校准"
    }
  }
];